//Components
import React, { useState, useEffect, useRef } from 'react'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal'
import Form from 'react-bootstrap/Form';
import { useParams, useNavigate } from 'react-router-dom';
import { Header } from '../common/Header/Header'
import QRCode from "react-qr-code";
import Badge from 'react-bootstrap/Badge';
import Spinner from 'react-bootstrap/Spinner';

//Utils
import { RenderIf } from '../../utils/RenderIf';
import Socket from '../../utils/Socket.config';
import { FormatDateTime } from '../../utils/FormatDate';

//PDF
import { PDFDownloadLink } from '@react-pdf/renderer';
import DocPdf from '../Pdf/DocPdf';
//Icons
import { BsCheckLg } from "react-icons/bs";
//API
import { OrdersFetchAPI } from '../../api/Orders';
import { BusinessFetchAPI } from '../../api/Business';
import { DgiFetchAPI } from '../../api/Dgi';
import { BranchOfficeFetchAPI } from '../../api/BranchOffices';
import { AsapFetchAPI } from '../../api/Asap';
import { TookanFetchAPI } from '../../api/Tookan';
import { DeliveryOrdersFetchAPI } from '../../api/DeliveryOrders';
//img
import logo_sp from '../img/logos/logo.png';
import './cart.css';
import Swal from 'sweetalert2';

import HeaderMain from '../Home/Headers/HeaderMain';
import Loader from '../Home/Loader';
import LoginUser from '../Profile/LoginUser';
import ErrorAlert from '../Alerts/ErrorAlert';
import AlertSmall from '../Alerts/AlertSmall';
import { buildCloudinaryImageUrl } from '../../utils/CloudinaryImageUrl';

const OrderToApprove = () => {
  const navigate = useNavigate();
  //State for show modal
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [formatVoucher, setformatVoucher] = useState("");
  const [modalShowVoucher, setmodalShowVoucher] = useState(false)
  const [loginrequired, setLoginRequired] = useState(false);
  const [modalUser, setModalUser] = React.useState(false);
  // Keep a persistent socket reference and a flag to avoid double-emits
  const socketRef = useRef(null);
  const emailedRef = useRef(false);
  //State for rejected order
  const [isRejected, setIsRejected] = useState(false);
  const [rejectInfo, setRejectInfo] = useState({ reason: '', at: null });
  //State client data
  const [clientData, setClientData] = useState(() => {
    if (localStorage.getItem('client') != null && localStorage.getItem('client') != undefined && localStorage.getItem('client') != '') {
      return JSON.parse(localStorage.getItem('client'))
    } else {
      return null
    }
  })
  const [guestClient, setGuestClient] = useState(() => {
    if (localStorage.getItem('guestClient') != null && localStorage.getItem('guestClient') != undefined && localStorage.getItem('guestClient') != '') {
      return localStorage.getItem('guestClient')
    } else {
      return null
    }
  });
  //State order data 
  const { order_code } = useParams();
  const [branchoffice_code, setBranchOfficeCode] = useState(() => {
    if (localStorage.getItem("branchoffice") != "" && localStorage.getItem("branchoffice") != undefined) {
      return JSON.parse(localStorage.getItem("branchoffice")).code
    }
  });
  const [business_code, setbusiness_code] = useState(() => {
    if (localStorage.getItem("business") != "" && localStorage.getItem("business") != undefined) {
      return JSON.parse(localStorage.getItem("business")).code
    }
  });
  const [branchoffice_id, setbranchoffice_id] = useState(() => {
    if (localStorage.getItem("branchoffice") != "" && localStorage.getItem("branchoffice") != undefined) {
      return JSON.parse(localStorage.getItem("branchoffice")).id
    }
  });
  const [machine_code_table, setmachine_code_table] = useState(() => {
    if (localStorage.getItem("machine") != "" && localStorage.getItem("machine") != undefined) {
      return JSON.parse(localStorage.getItem("machine")).code
    }
  });

  const [addressNowLocation, setAddressNowLocation] = useState(() => {
    if (localStorage.getItem('addressNowLocation') != null && localStorage.getItem('addressNowLocation') != undefined && localStorage.getItem('addressNowLocation') != '') {
      return JSON.parse(localStorage.getItem('addressNowLocation'))
    } else {
      return null
    }
  });

  const [eventHandler, setEventHandler] = useState(0);
  const [orderData, setOrderData] = useState({
    createdAt: "2023-07-25T10:02:35.000+00:00",
    cufe: "0",
    dgi_qr: "0"

  });
  const [cardsItems, setCardItems] = useState([]);
  const [listOrderHistroy, setOrderHistory] = useState([]);
  const [businessData, setBusinessData] = useState({
    name: ''
  });
  const [branchOfficeData, setBranchofficeData] = useState({
    "ruc": "",
    "dv": "",
    "name": "",
    "ruc_type": "",
    "direction": "",
    "dgi_name": "",
  });


  //Total taxes 
  const [totalTaxes, setTotalTaxes] = useState([
    { total_base: 0, tax: "0%", total_tax: 0 },
    { total_base: 0, tax: "7%", total_tax: 0 },
    { total_base: 0, tax: "10%", total_tax: 0 },
    { total_base: 0, tax: "15%", total_tax: 0 }
  ]);

  // Status map  ASAP
  const ASAP_STATUS_MAP = {
    0: { key: 'placed', label: 'Order Placed' },
    6: { key: 'confirmed', label: 'Order Confirmed' },
    7: { key: 'dispatched', label: 'Order Dispatched' },
    2: { key: 'completed', label: 'Order Completed' },
    1: { key: 'cancelled', label: 'Order Cancelled' },
    100: { key: 'driver_arrived', label: 'Driver Arrived' },
    101: { key: 'driver_started', label: 'Driver Started' },
  };

  // Tookan: status map (basado en job_status)
  const TOOKAN_STATUS_MAP = {
    0: { key: 'placed', label: 'Task Created' },
    1: { key: 'assigned', label: 'Assigned' },    // algunas cuentas usan 1
    10: { key: 'assigned', label: 'Assigned' },    // otras 10
    6: { key: 'arrived', label: 'Driver Arrived' },
    2: { key: 'started', label: 'Picked Up' },
    3: { key: 'completed', label: 'Completed' },
    4: { key: 'failed', label: 'Failed' },
    9: { key: 'cancelled', label: 'Cancelled' },
    11: { key: 'in_progress', label: 'In Progress' }
  };

  // Flow para cada plataforma
  const ASAP_FLOW = ['placed', 'confirmed', 'dispatched', 'completed'];
  const TOOKAN_FLOW = ['placed', 'assigned', 'arrived', 'started', 'completed'];

  // Decide platform (se recalcula en cada render según orderData)
  const PLATFORM = (orderData?.delivery?.platform || '').toLowerCase();
  const STATUS_MAP = PLATFORM === 'tookan' ? TOOKAN_STATUS_MAP : ASAP_STATUS_MAP;
  const FLOW = PLATFORM === 'tookan' ? TOOKAN_FLOW : ASAP_FLOW;

  // UI state Tracking
  const [trackOpen, setTrackOpen] = useState(false);
  const [trackLoading, setTrackLoading] = useState(false);
  const [trackLog, setTrackLog] = useState([]);
  const [tookanTrackingLink, setTookanTrackingLink] = useState(null);
  const pollRef = useRef(null);

  // Derivados (usando el normalizador unificado)
  const latestEvent = trackLog?.[0] || null; // log en DESC
  const latestStatusCode = latestEvent?.code ?? null;
  const latestKey = STATUS_MAP[latestStatusCode]?.key ?? null;
  const isTerminal = latestKey === 'completed' || latestKey === 'cancelled' || latestKey === 'failed';
  const currentStepIndex = (() => {
    if (!latestKey) return -1;
    const idx = FLOW.indexOf(latestKey);
    return idx >= 0 ? idx : -1;
  })();

  // 1) Helper: mapea label_description/description a un status code Tookan
  const mapTookanLabelToCode = (textRaw) => {
    if (!textRaw) return null;
    const text = textRaw.replace(/<[^>]+>/g, '').toUpperCase(); // strip HTML + normalize

    // Orden importa: de más específico a más general
    if (/\b(COMPLETED|SUCCESS|TASK\s+COMPLETED)\b/.test(text)) return 3;           // completed
    if (/\b(PICKED|PICK\s?UP|STARTED|TASK\s+STARTED)\b/.test(text)) return 2;      // started/picked up
    if (/\b(ARRIVED|REACHED|AT\s+PICKUP|AT\s+DELIVERY|TASK\s+ARRIVED)\b/.test(text)) return 6; // arrived
    if (/\b(ASSIGNED|ACCEPTED|ACKNOWLEDGED|AUTO[-\s]?ASSIGNED)\b/.test(text)) return 10; // assigned
    if (/\b(EN[\s-]?ROUTE|ENROUTE|ON\s+THE\s+WAY)\b/.test(text)) return 11;        // in progress
    if (/\b(CANCEL|CANCELLED|UNASSIGNED)\b/.test(text)) return 9;                  // cancelled/unassigned
    if (/\b(FAILED|FAIL)\b/.test(text)) return 4;                                   // failed
    if (/\b(CREATED|NEW|TASK\s+CREATED|BY\s+API)\b/.test(text)) return 0;          // created/placed
    return null; // sin match
  };

  // Normaliza eventos para UI
  const normalizeEvent = (e) => {
    if (PLATFORM === 'tookan') {
      const ts =
        e?.creation_datetime ||
        e?.datetime ||
        e?.logged_at ||
        e?.created_at ||
        e?.date ||
        e?.timestamp ||
        null;

      // armamos un texto base para mapear
      const labelDesc = e?.label_description || e?.description || e?.activity || '';
      let code = mapTookanLabelToCode(labelDesc);

      const label =
        (e?.label_description?.replace(/<[^>]+>/g, '') ||
          e?.description ||
          e?.activity ||
          'Status');

      const description = e?.description || '';

      return {
        id: e?.id || `${code ?? 'x'}-${ts}-${Math.random().toString(36).slice(2)}`,
        code,          // puede quedar null; luego haremos fallback con job_status
        label,
        description,
        at: ts
      };
    }

    // ASAP (igual que ya lo tenías)
    const code = e?.delivery_status ?? e?.status ?? null;
    const ts = e?.logged_at || e?.created_at || e?.date || e?.timestamp || null;
    return {
      id: e?.id || `${code}-${ts}-${Math.random().toString(36).slice(2)}`,
      code,
      label: ASAP_STATUS_MAP[code]?.label || (e?.title ?? `Status ${code}`),
      description: e?.description || e?.message || '',
      at: ts,
    };
  };

  const isApprovedOrder = (order) => Number(order?.status_id) === 1;

  const getApprovedOrderCode = (order) => (
    order?.finished_order_reference?.code ||
    order?.finished_order_reference?.order_code ||
    order?.finished_order_reference?.transaction_code ||
    order?.finished_order?.code ||
    order?.finished_order?.order_code ||
    order?.finished_order?.transaction_code ||
    order?.metadata?.response_registration?.order_code ||
    order?.response_registration?.order_code
  );

  const redirectApprovedOrder = (order) => {
    if (!isApprovedOrder(order)) return false;

    const approvedOrderCode = getApprovedOrderCode(order);
    if (!approvedOrderCode) {
      setIsRejected(false);
      return false;
    }

    navigate(`/order/${approvedOrderCode}`);
    return true;
  };


  //Function to get a temporal order data by code
  const getTemporalOrderByCode = async (code) => {
    try {
      let token = undefined;
      const response = await OrdersFetchAPI.getTempOrderByCode(code, business_code, branchoffice_code, token);
      //console.log(response);
      return response;
    } catch (err) {
      //console.log(err);
    }
  }


  // function convert format voucher
  const formatVoucherString = () => {
    let voucher = orderData.voucher_response
    // Extraer el número de tarjeta ocultando los dígitos intermedios
    const maskedVoucher = voucher.replace(/(\d{6})\d+(\d{4})/g, "$1XXXXXX$2");

    // Construir el string formateado del voucher
    const formattedVoucher = `${maskedVoucher}`;
    setformatVoucher(formattedVoucher)
    //return formattedVoucher;
  };

  const handleViewCoucher = () => {
    formatVoucherString()
    setmodalShowVoucher(true)
  }


  //We get the page data 
  useEffect(() => {
    (async () => {
      try {
        const response = await getTemporalOrderByCode(order_code);
        //console.log(response);
        if (localStorage.getItem('guestClient') !== null && localStorage.getItem('guestClient') !== undefined && localStorage.getItem('guestClient') !== 0 && localStorage.getItem('guestClient') !== "0") {
          localStorage.setItem('lastorderguest', JSON.stringify(response.data.order));
        }

        const order = response?.data?.order;
        if (!order) return;

        //We check the status of the order to redirect if necessary
        if (redirectApprovedOrder(order)) {
          return;
        } else {
          //We check if the order was rejected
          if (Number(order.status_id) === 8) {
            setIsRejected(true);
            setRejectInfo({
              reason: order?.rejected?.reason || 'No se especificó un motivo.',
              at: order?.rejected?.at || new Date().toISOString()
            });
          }
          setOrderData(order);
          setCardItems(order.groups || []);
          setOrderHistory(order.status_update_history || []);
          //We get the business
          const response_business = await BusinessFetchAPI.getBusinessByCode(order.business.code)
          //We set the business data 
          setBusinessData(response_business.data.business)
          //We get the branchoffice info 
          const response_branch = await BranchOfficeFetchAPI.getBranchOfficeByCode(order.business.code, order.branchoffice.code);
          //We set the business data 
          setBranchofficeData(response_branch.data.branchoffice);
          try {
            //We get the dgi info 
            const dgi_info_branch = await DgiFetchAPI.checkDGIContribuyent(response_branch.data.branchoffice.ruc);
            //console.log(dgi_info_branch)
            //setBranchofficeData( {dgi_name: dgi_info_branch.data.dgi_response.dNomb}, ...branchOfficeData)
          } catch (err) {
            //console.log(err)
          }
        }
      } catch (err) {
        //console.log(err)
      }



    })()
  }, []);

  // Socket connection and events
  useEffect(() => {
    //Connection with the sockets server 
    socketRef.current = Socket({ branchoffice_id, order_code });

    //We update the estate of the order depending of the signal of the order 
    socketRef.current.on(`branchoffice_${branchoffice_id}_orderUpdated_${order_code}`, (updatedOrder) => {
      //console.log(updatedOrder)
      if (redirectApprovedOrder(updatedOrder)) {
        return;
      }
      //We set orders history 
      setOrderHistory(updatedOrder.status_update_history || []);
      //We refresh
      setEventHandler(1)
    });

    //We listen the updated event of the delivery (pos) update this event is to know if the order was approved or rejected
    socketRef.current.on(`delivery_order_updated`, (updatedOrder) => {
      //console.log("updatedOrder by delivery pos", updatedOrder)
      //We navigate to order confirmation
      if (updatedOrder.status === "order_accepted") {
        //We navigate to order confirmation
        const approvedOrderCode = getApprovedOrderCode(updatedOrder);
        if (approvedOrderCode) {
          navigate(`/order/${approvedOrderCode}`);
        }
      }
      //We check if the order was rejected
      if (updatedOrder.status === "rejected") {
        // intenta tomar una razón si viene en el payload
        const reason =
          updatedOrder?.metadata?.reject_reason ||
          updatedOrder?.metadata?.rejection_reason ||
          updatedOrder?.justification ||
          updatedOrder?.metadata?.justification ||
          '';

        setIsRejected(true);
        setRejectInfo({
          reason,
          at: updatedOrder?.updatedAt || updatedOrder?.createdAt || new Date().toISOString()
        });

        // opcional: cortar polling de tracking si está abierto
        if (pollRef.current) {
          clearInterval(pollRef.current);
          pollRef.current = null;
        }
      }
    });

    // Listen for email notify result (optional UX/log)
    socketRef.current.on('orderEmailNotifyResult', (res) => {
      //console.log('[socket] orderEmailNotifyResult', res);
      // You can show a toast if you want:
      // if (res.success) Swal.fire({ toast:true, icon:'success', title:'Correo de orden enviado', timer:2000, showConfirmButton:false });
      // else if (res.duplicate || res.skipped) console.info('Email already handled/skipped');

    });

    // When the component is over, we  disconect the client of the socket 
    return () => {
      // Clean up
      try { socketRef.current?.off('orderEmailNotifyResult'); } catch { }
      try { socketRef.current?.disconnect(); } catch { }
      socketRef.current = null;
    };
  }, [order_code])


  useEffect(() => {
    //We set orders history 
    setOrderHistory(listOrderHistroy);
    setEventHandler(0)
  }, [eventHandler])

  // Fetch delivery log
  const fetchDeliveryLogOnly = async () => {
    try {
      setTrackLoading(true);

      // external id esperado por tus APIs
      const externalOrderId = orderData?.delivery?.order_id || null;

      if (orderData?.delivery?.platform === "asap") {
        const res = await AsapFetchAPI.getAsapOrderLogStatus(
          undefined,
          branchoffice_id,
          externalOrderId
        );
        const raw = Array.isArray(res?.data?.delivery_log?.delivery_log)
          ? res.data.delivery_log.delivery_log
          : [];

        const ordered = [...raw].sort((a, b) =>
          new Date(b.logged_at || b.created_at || b.date || b.timestamp) -
          new Date(a.logged_at || a.created_at || a.date || a.timestamp)
        ).map(normalizeEvent);

        setTrackLog(ordered);
      } else if (orderData?.delivery?.platform === "tookan") {
        // Asegúrate que externalOrderId sea el job_id real
        const res = await TookanFetchAPI.getTookanOrderDetails(
          undefined,
          orderData.business.id,
          externalOrderId
        );
        // res.data = { message, status, data:[{...job...}] }
        const job = Array.isArray(res?.data?.raw.data) ? res.data.raw.data[0] : null;
        if (!job) {
          setTrackLog([]);
          setTookanTrackingLink(null);
          return;
        }

        setTookanTrackingLink(job?.tracking_link || null);

        const history = Array.isArray(job.task_history) ? job.task_history : [];
        const ordered = [...history].sort((a, b) =>
          new Date(b?.creation_datetime || 0) - new Date(a?.creation_datetime || 0)
        ).map(normalizeEvent);

        if (!ordered.length) {
          ordered.push(normalizeEvent({
            label_description: 'CREATED',
            creation_datetime: job.creation_datetime
          }));
        }

        // Fallback: si el último evento no tiene code, usamos job_status
        const latest = ordered[0];
        const codeFromJob = Number(job?.job_status);
        if (latest && (latest.code === null || latest.code === undefined) && !Number.isNaN(codeFromJob)) {
          latest.code = codeFromJob;
        }

        setTrackLog(ordered);
      }
    } catch (err) {

    } finally {
      setTrackLoading(false);
    }
  };

  // Open/close + polling
  const openTracking = async () => {
    setTrackOpen(true);
    await fetchDeliveryLogOnly();

    if (!pollRef.current) {
      pollRef.current = setInterval(async () => {
        await fetchDeliveryLogOnly();
      }, 12000);
    }
  };

  const closeTracking = () => {
    setTrackOpen(false);
    if (pollRef.current) {
      clearInterval(pollRef.current);
      pollRef.current = null;
    }
  };

  // Stop polling on terminal
  useEffect(() => {
    if (isTerminal && pollRef.current) {
      clearInterval(pollRef.current);
      pollRef.current = null;
    }
  }, [isTerminal]);



  //We charge the items of the order
  const orderItems = () => {
    let items = cardsItems.map((options) => (
      <>
        <div className="d-flex  pt-3 px-xs-2" key={options._id}>
          <img className="bd-placeholder-img flex-shrink-0 me-2 rounded" src={buildCloudinaryImageUrl({ url: options.img, width: 300, quality: "auto", type: "image" }) || undefined} width="42" height="42" />
          <div className="pb-3 mb-0  lh-sm  w-100">
            <div className="d-flex justify-content-between ">
              {/* Name */}
              <span className=" fw-bold">{options.name}</span>
              {/* Cantidad/ Quantity*/}
              <div>
                <span className='px-3'>x{options.amount} </span>
                <label className="fw-bold text-theme" >{options.price.toFixed(2)}</label>
              </div>

            </div>
            {/** Segment items */}
            <>
              <div className="d-flex justify-content-between">
                {/* Name */}
                <span className="">Descuento</span>
                {/* Cantidad/ Quantity*/}
                <div>
                  <label className={options.discount === undefined ? "" : "text-danger"}>{options.discount === undefined ? "No registrado" : "- $" + options.discount.toFixed(2)}</label>
                </div>
              </div>
              {options.segments.map((segments) => (
                <div className="d-flex justify-content-between">
                  {/* item name */}
                  <span className="">{segments.item.name}</span>
                </div>
              ))}
            </>
          </div>
        </div>


        {options.note && options.note !== "" ? <>
          <div className="d-flex justify-content-between ">
            {/* Name */}
            <span className=" fw-bold"><i class="uil uil-comment-notes"></i> Nota</span>
          </div>
          <div className="d-block text-break">
            <span className="">{options.note}</span>
          </div></> : <></>}



        {options.type === "reservable" && options.reservation_code && options.reservation_code !== "" ? <>
          <div className="d-flex justify-content-center">
            <div>
              <span className="">Código QR</span>
              <div>
                <QRCode value={options.reservation_code}
                  size={150}
                  bgColor="#ffffff" // Color de fondo
                  fgColor="#000000" // Color del texto
                  level="H" />
              </div>
            </div>
          </div></> : <></>}

      </>


    ))
    return <> {items}</>
  }



  const closedModalLoginAndRegister = () => {
    setClientData(JSON.parse(localStorage.getItem('client')))
    setLoginRequired(false);
  }





  const [loading, setLoading] = useState(true);
  const paymentInfo = orderData?.payment_info || {};

  const showGuest = guestClient !== 0 && guestClient !== "0"

  /* ══════════════════════════════════════════
     ICONS
  ══════════════════════════════════════════ */
  const Ico = ({ d, size = 14 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
      stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      {d}
    </svg>
  );

  const IcoBell = () => <Ico d={<><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" /><path d="M13.73 21a2 2 0 0 1-3.46 0" /></>} />;
  const IcoReceipt = () => <Ico d={<><polyline points="6 9 6 2 18 2 18 9" /><path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2" /><rect x="6" y="14" width="12" height="8" /></>} />;
  const IcoTruck = () => <Ico d={<><rect x="1" y="3" width="15" height="13" /><polygon points="16 8 20 8 23 11 23 16 16 16 16 8" /><circle cx="5.5" cy="18.5" r="2.5" /><circle cx="18.5" cy="18.5" r="2.5" /></>} />;
  const IcoHome = () => <Ico d={<><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" /><polyline points="9 22 9 12 15 12 15 22" /></>} />;
  const IcoUser = () => <Ico d={<><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" /><circle cx="12" cy="7" r="4" /></>} />;
  const IcoX = () => <Ico d={<><circle cx="12" cy="12" r="10" /><line x1="15" y1="9" x2="9" y2="15" /><line x1="9" y1="9" x2="15" y2="15" /></>} />;
  const IcoInfo = () => <Ico d={<><circle cx="12" cy="12" r="10" /><line x1="12" y1="8" x2="12" y2="12" /><line x1="12" y1="16" x2="12.01" y2="16" /></>} />;
  const IcoCal = () => <Ico d={<><rect x="3" y="4" width="18" height="18" rx="2" ry="2" /><line x1="16" y1="2" x2="16" y2="6" /><line x1="8" y1="2" x2="8" y2="6" /><line x1="3" y1="10" x2="21" y2="10" /></>} />;
  const IcoWarn = () => <Ico d={<><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" /><line x1="12" y1="9" x2="12" y2="13" /><line x1="12" y1="17" x2="12.01" y2="17" /></>} />;
  const IcoRefresh = () => <Ico d={<><polyline points="23 4 23 10 17 10" /><path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10" /></>} />;
  const IcoClock = () => <Ico d={<><circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" /></>} />;
  const IcoPin = () => <Ico d={<><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" /><circle cx="12" cy="10" r="3" /></>} />;
  const IcoCheck = ({ size = 12 }) => <Ico size={size} d={<polyline points="20 6 9 17 4 12" />} />;
  const IcoArrow = () => <Ico size={13} d={<><line x1="5" y1="12" x2="19" y2="12" /><polyline points="12 5 19 12 12 19" /></>} />;
  return (
    <>
      {loading && <Loader onFinish={() => setLoading(false)} />}
      {!loading &&
        (<>

          <div className="or-root">
            <HeaderMain />

            {/* ════════ GUEST — card flotante desktop ════════ */}
            {showGuest && (
              <div className="or-guest-float" onClick={() => setLoginRequired(true)}>
                <button className="or-guest-float-cta">
                  <IcoUser /> Regístrate gratis <IcoArrow />
                </button>
              </div>
            )}

            {loginrequired === false ? (
              <div className="or-page mt-lg-5 mt-5">

                {/* ════════ Modal: Número de mesa ════════ */}
                <Modal show={show} onHide={handleClose} centered className="or-modal">
                  <Modal.Header closeButton>
                    <Modal.Title>Número de mesa</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <Form>
                      <Row className="justify-content-md-center">
                        <Col md="auto">
                          <Form.Control className="w-100 or-input" placeholder="Ingrese el número" />
                        </Col>
                      </Row>
                    </Form>
                  </Modal.Body>
                  <Modal.Footer>
                    <button className="or-btn or-btn-outline" onClick={handleClose}>Cerrar</button>
                    <button className="or-btn or-btn-primary" onClick={handleClose}>Guardar</button>
                  </Modal.Footer>
                </Modal>

                {/* ════════ GUEST — aviso de cuenta ════════ */}
                {showGuest && (
                  <div className="or-guest" onClick={() => setLoginRequired(true)}>
                    <span className="or-guest-icon"><IcoWarn /></span>
                    <div className="or-guest-body">
                      <p className="or-guest-title">Aún no tienes cuenta</p>
                      <p className="or-guest-sub">Para una mejor experiencia, crea tu perfil.</p>
                    </div>
                    <a className="or-guest-link" href="#">
                      <IcoUser /> Regístrate aquí
                    </a>
                  </div>
                )}

                {/* ════════ 1–3. Estado + cuándo + mensaje ════════ */}
                <div className="or-group">
                  <section className="or-card or-status">

                    <div className="or-status-top">
                      <div className="or-status-main">

                        {/* Estado */}
                        {!isRejected ? (
                          <span className="or-badge" data-tone="yellow">
                            <span className="or-badge-dot" />
                            Pendiente de aprobación
                          </span>
                        ) : null}

                        {/* Tipo de orden (programado o normal) */}
                        {(orderData?.order_type || orderData?.is_scheduled) && (
                          <h1 className="or-status-title or-capitalize">
                            {orderData?.is_scheduled
                              ? (orderData.order_type === "delivery" ? "Delivery programado" : "Pick & Go programado")
                              : orderData.order_type === "delivery" ? "Delivery"
                                : orderData.order_type === "pickngo" ? "Pick & Go"
                                  : orderData.order_type}
                          </h1>
                        )}
                      </div>

                      {/* Datos del programado */}
                      {orderData?.is_scheduled && (
                        <dl className="or-meta">
                          <div className="or-meta-item">
                            <IcoClock />
                            <div>
                              <dt>Hora</dt>
                              <dd>{FormatDateTime(orderData.scheduled_for, orderData.scheduled_timezone)}</dd>
                            </div>
                          </div>

                          {orderData?.scheduled_window?.start && orderData?.scheduled_window?.end && (
                            <div className="or-meta-item">
                              <IcoCal />
                              <div>
                                <dt>Ventana de retiro</dt>
                                <dd>
                                  {FormatDateTime(orderData.scheduled_window.start, orderData.scheduled_timezone)}
                                  {" – "}
                                  {FormatDateTime(orderData.scheduled_window.end, orderData.scheduled_timezone)}
                                </dd>
                              </div>
                            </div>
                          )}

                          {orderData?.scheduled_timezone && (
                            <div className="or-meta-item">
                              <IcoPin />
                              <div>
                                <dt>Zona</dt>
                                <dd>{orderData.scheduled_timezone}</dd>
                              </div>
                            </div>
                          )}
                        </dl>
                      )}
                    </div>

                    {/* Rechazada */}
                    {isRejected && (
                      <div className="or-rejected">
                        <span className="or-rejected-icon"><IcoX /></span>
                        <div className="or-rejected-body">
                          <p className="or-rejected-title">Orden rechazada</p>
                          <p className="or-rejected-reason">
                            {rejectInfo?.reason
                              ? <><strong>Motivo:</strong> {rejectInfo.reason}</>
                              : <>No se especificó un motivo.</>}
                          </p>
                          {rejectInfo?.at && (
                            <p className="or-rejected-at">
                              Actualizado: {FormatDateTime(rejectInfo.at)}
                            </p>
                          )}
                          <button className="or-btn or-btn-outline or-btn-sm" onClick={() => navigate("/home")}>
                            <IcoHome /> Volver al inicio
                          </button>
                        </div>
                      </div>
                    )}
                  </section>

                  {orderData?.is_scheduled && (
                    <p className="or-note">
                      <IcoInfo />
                      <span>Te avisaremos aquí cuando tu pedido esté listo. Muestra el número de orden en caja.</span>
                    </p>
                  )}
                </div>

                {/* ════════ Tracking button ════════ */}
                <RenderIf isTrue={
                  orderData.delivery &&
                  orderData.delivery.platform !== "smartpay" &&
                  orderData.delivery.order_id &&
                  orderData.delivery.order_id !== ""
                }>
                  <div className="or-action-row">
                    <button className="or-btn or-btn-outline" onClick={openTracking}>
                      <IcoTruck /> Seguimiento de delivery
                    </button>
                  </div>
                </RenderIf>

                {/* ════════ 4. Información del pedido ════════ */}
                <section className="or-card or-identity">
                  <div>
                    <h2 className="or-business-name">{businessData.name}</h2>
                    <p className="or-order-ref">
                      Orden <span className="or-order-number">{orderData.transaction_code}</span>
                    </p>
                  </div>
                  <p className="or-notifier">
                    <IcoBell /> Notificador <b>{orderData.locator}</b>
                  </p>
                </section>

                {/* ════════ 5–6. Productos + Resumen ════════ */}
                <div className="or-grid">

                  <section className="or-card or-products">
                    <header className="or-card-head">
                      <h2 className="or-section-title">Productos</h2>
                    </header>
                    <div className="or-items">
                      {orderItems()}
                    </div>
                  </section>

                  <aside className="or-card or-summary">
                    <header className="or-card-head">
                      <h2 className="or-section-title">Resumen</h2>
                    </header>

                    <dl className="or-summary-rows">
                      <div className="or-summary-row">
                        <dt className="or-summary-label">Subtotal</dt>
                        <dd className="or-summary-value">
                          ${typeof orderData.subtotal === "number"
                            ? orderData.subtotal.toFixed(2)
                            : orderData.subtotal}
                        </dd>
                      </div>

                      <div className="or-summary-row">
                        <dt className="or-summary-label">Descuento</dt>
                        <dd className="or-summary-value or-summary-discount">
                          −${typeof orderData.subtotal === "number"
                            ? orderData.discount.toFixed(2)
                            : orderData.discount}
                        </dd>
                      </div>

                      <RenderIf isTrue={orderData.delivery !== undefined && orderData.delivery !== null}>
                        <div className="or-summary-row">
                          <dt className="or-summary-label">Delivery</dt>
                          <dd className="or-summary-value">
                            ${typeof orderData.delivery?.value === "number"
                              ? orderData.delivery.value.toFixed(2)
                              : orderData.delivery?.value}
                          </dd>
                        </div>
                      </RenderIf>

                      <div className="or-summary-row">
                        <dt className="or-summary-label">ITBMS</dt>
                        <dd className="or-summary-value">
                          ${typeof orderData.tax === "number"
                            ? orderData.tax.toFixed(2)
                            : orderData.tax}
                        </dd>
                      </div>
                    </dl>

                    <div className="or-total-row">
                      <span className="or-total-label">Total a pagar</span>
                      <span className="or-total-amount">
                        ${typeof orderData.total === "number"
                          ? orderData.total.toFixed(2)
                          : orderData.total}
                      </span>
                    </div>
                  </aside>
                </div>

                {/* ════════ 7. Pago por transferencia ════════ */}
                {paymentInfo?.bank_name && (
                  <section className="or-card or-payment">
                    <header className="or-card-head">
                      <h2 className="or-section-title">Pago por transferencia</h2>
                    </header>

                    <dl className="or-bank">
                      <div className="or-bank-row">
                        <dt className="or-bank-label">Banco</dt>
                        <dd className="or-bank-value">{paymentInfo.bank_name}</dd>
                      </div>

                      <div className="or-bank-row">
                        <dt className="or-bank-label">Tipo de cuenta</dt>
                        <dd className="or-bank-value">{paymentInfo.account_type}</dd>
                      </div>

                      <div className="or-bank-row or-bank-row-account">
                        <dt className="or-bank-label">Número de cuenta</dt>
                        <dd className="or-bank-value or-bank-account">{paymentInfo.account_number}</dd>
                      </div>

                      <div className="or-bank-row">
                        <dt className="or-bank-label">Titular</dt>
                        <dd className="or-bank-value">{paymentInfo.account_holder}</dd>
                      </div>
                    </dl>

                    <p className="or-bank-note">
                      <IcoInfo />
                      <span>Realiza la transferencia y envía tu comprobante para validar el pago.</span>
                    </p>
                  </section>
                )}

                {/* ════════ 8. Acciones ════════ */}
                <div className="or-actions">
                  {orderData.voucher_response !== "0" && orderData.voucher_response !== 0 && (
                    <button className="or-btn or-btn-outline" onClick={handleViewCoucher}>
                      <IcoReceipt /> Voucher
                    </button>
                  )}
                  <button className="or-btn or-btn-primary or-actions-home" onClick={() => navigate("/home")}>
                    <IcoHome /> Ir al inicio
                  </button>
                </div>

                {/* ════════ Barra fija (solo mobile) ════════ */}
                <div className="or-sticky">
                  <div className="or-sticky-total">
                    <span>Total a pagar</span>
                    <strong>
                      ${typeof orderData.total === "number"
                        ? orderData.total.toFixed(2)
                        : orderData.total}
                    </strong>
                  </div>
                  <button className="or-btn or-btn-primary" onClick={() => navigate("/home")}>
                    <IcoHome /> Ir al inicio
                  </button>
                </div>

                {/* ════════ Modal: Tracking ════════ */}
                <Modal show={trackOpen} onHide={closeTracking} size="lg" centered className="or-modal">
                  <Modal.Header closeButton>
                    <Modal.Title>Seguimiento de delivery</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <p className="or-modal-lead">Seguimiento de tu entrega en tiempo real.</p>

                    {orderData?.delivery?.platform === "tookan" && (
                      <div className="or-track-link">
                        <a href={tookanTrackingLink} target="_blank" rel="noreferrer"
                          className="or-btn or-btn-outline or-btn-sm">
                          Ver enlace de tracking
                        </a>
                      </div>
                    )}

                    <div className="or-track-head">
                      <div className="or-track-state">
                        Estado:
                        {trackLoading ? (
                          <span className="or-track-loading">Cargando...</span>
                        ) : (
                          <span className={`or-track-pill ${latestKey === "completed" ? "or-track-pill-success"
                            : latestKey === "cancelled" ? "or-track-pill-danger"
                              : "or-track-pill-default"
                            }`}>
                            {latestEvent?.label || "—"}
                          </span>
                        )}
                      </div>
                      {latestEvent?.at && (
                        <span className="or-track-at">{FormatDateTime(latestEvent.at)}</span>
                      )}
                    </div>

                    <div className="or-stepper">
                      {FLOW.map((step, i) => {
                        const active = currentStepIndex >= i;
                        const connected = currentStepIndex > i;
                        const label =
                          step === "placed" ? "Recibido" :
                            step === "assigned" ? "Asignado" :
                              step === "arrived" ? "En camino" :
                                step === "started" ? "Recogido" : "Entregado";
                        return (
                          <div key={step} className="or-step-wrap">
                            <div className="or-step">
                              <div className={`or-step-circle${active ? " active" : ""}`}>
                                {active && <IcoCheck size={10} />}
                              </div>
                              <span className={`or-step-name${active ? " active" : ""}`}>{label}</span>
                            </div>
                            {i < FLOW.length - 1 && (
                              <div className={`or-step-line${connected ? " active" : ""}`} />
                            )}
                          </div>
                        );
                      })}
                    </div>

                    <p className="or-modal-eyebrow">Historial</p>

                    {trackLog?.length ? (
                      <div className="or-log">
                        {trackLog.map((e, idx) => (
                          <div className="or-log-item" key={e.id}>
                            <div className="or-log-main">
                              <div className={`or-log-dot${idx === 0 ? " latest" : ""}`} />
                              <div>
                                <div className="or-log-name">{e.label}</div>
                                <div className="or-log-desc">{e.description}</div>
                              </div>
                            </div>
                            <div className="or-log-time">{e.at ? FormatDateTime(e.at) : ""}</div>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <p className="or-empty">
                        {trackLoading ? "Cargando eventos..." : "Sin eventos registrados."}
                      </p>
                    )}
                  </Modal.Body>
                  <Modal.Footer>
                    <button className="or-btn or-btn-outline" onClick={closeTracking}>Cerrar</button>
                    <button className="or-btn or-btn-primary" onClick={fetchDeliveryLogOnly}>
                      <IcoRefresh /> Refrescar
                    </button>
                  </Modal.Footer>
                </Modal>

                {/* ════════ Modal: Voucher ════════ */}
                <Modal show={modalShowVoucher} onHide={() => setmodalShowVoucher(false)}
                  size="lg" centered className="or-modal">
                  <Modal.Header closeButton>
                    <Modal.Title>Voucher #{orderData.transaction_code}</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <pre className="or-voucher">{formatVoucher}</pre>
                  </Modal.Body>
                  <Modal.Footer>
                    <button className="or-btn or-btn-primary" onClick={() => setmodalShowVoucher(false)}>
                      Cerrar
                    </button>
                  </Modal.Footer>
                </Modal>

              </div>
            ) : (
              <LoginUser
                modalUser={modalUser}
                setModalUser={setModalUser}
                shoppingCart={true}
                closedModalLoginAndRegister={closedModalLoginAndRegister}
              />
            )}
          </div>


        </>)


      }



    </>
  )
}

export default OrderToApprove
